import PoliceReportCheckbox from "./components/PoliceReportCheckbox";

export default function ChecklistColumn({ caseObj, viewPermissions }) {
  return (
    <div className="h-fit rounded-md p-2">
      {!viewPermissions ? (
        <h2 className="my-2 text-center text-gray-500 underline">
          Content details not available for this account
        </h2>
      ) : (
        <>
          <PoliceReportCheckbox caseObj={caseObj} />
        </>
      )}
    </div>
  );
}
